/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Change_Applied_B_To_AInputs */



/**
* | output |
* | --- |
* | "Change applied from Group B to Group A" |
*
* @param {Compare_Event_Groups_Change_Applied_B_To_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_change_applied_b_to_a = /** @type {((inputs?: Compare_Event_Groups_Change_Applied_B_To_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Change_Applied_B_To_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modification appliquée du groupe B au groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderung von Gruppe B auf Gruppe A angewendet")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica applicata dal Gruppo B al Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменение внесено из группы B в группу A.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambio aplicado del Grupo B al Grupo A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从B组变更至A组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループBからグループAへの変更")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह B से समूह A में परिवर्तन लागू किया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alteração aplicada do Grupo B para o Grupo A")
	return /** @type {LocalizedString} */ ("Change applied from Group B to Group A")
});